import { Modal } from "@material-ui/core";
import TeacherPortalLearningMaterial from "./LearningMaterial";

const TeacherPortalLearningMaterialModal = ({ activityWithUsageData, onClose }) => (
    <Modal open onClose={() => { onClose() }}>
        <div className="fixed left-1/2 top-1/2 h-3/5 w-4/5 -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded border-0 bg-card shadow-large">
            <TeacherPortalLearningMaterial activityWithUsageData={activityWithUsageData} hasBeenOpen={true} />
        </div>
    </Modal>
);

export default TeacherPortalLearningMaterialModal;
